class progressBar {
    element: HTMLElement;
    triggerElement: HTMLElement;
    pageHeight: Number;

    constructor(){
        this.init();
    }

    init() {
        this.element =  document.querySelector('.progress-bar');
        this.triggerElement = document.querySelector('.page__content');
        this.pageHeight = this.triggerElement.offsetHeight - window.innerHeight;
        this.scrollAnim();
    }

    scrollAnim(){
        let tween = TweenMax.to(this.element,1,{scaleX:1, ease: Power0.easeNone});
        let x = new ScrollMagic.Scene({
            triggerElement: this.triggerElement,
            triggerHook: 0,
            duration:this.pageHeight
        })
            //.addIndicators()
            .setTween(tween)
            .addTo(Global.controller);
    }
}
